<div class="d-flex align-items-center justify-content-center me-2 mb-2 img-thumbnail">
  @if (isLoading) {
    <div class="spinner-wrapper d-flex align-items-center justify-content-center">
      <div class="spinner-border spinner text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div (click)="open()" class="cursor-pointer">
      <div class="img" [style.background-image]="'url(' + imgBase64  + ')'"></div>
    </div>
  }
</div>

